import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { CellProps } from '@components/DataGrid/types';
import StickyNoteIcon from '@mui/icons-material/StickyNote2TwoTone';
import { setModalSearchParameters } from '@hooks/useModalParams';
import { LegDetailsSubSection } from '@/ConsignmentDetails/LegsTab/types';

import styles from '../../RenderCell.module.css';

/**
 * Notes Cell Rendered Component for the Dispatch Board
 */
export default function NotesCell({ row }: CellProps<DispatchLeg>) {
	return (
		<StickyNoteIcon
			color={row.hasNotes ? 'info' : 'disabled'}
			className={styles['note-col-ico']}
			titleAccess='View Dispatch/Driver Notes'
			onClick={() => {
				setModalSearchParameters({
					form: 'consignmentDetails',
					formId: String(row.csnId),
					legId: String(row.legId),
					scrollTo: LegDetailsSubSection[LegDetailsSubSection.Notes]
				});
			}}
		/>
	);
}
